import React from 'react'
import Page from '../../components/page'

export default () => (
  <div className="home-page">
    <div className="container">
      <h1 className="page-title"></h1>
      <div className="trending">
    
      </div>
    </div>

    <Page title="Main_page" />
  </div>
)



// WEBPACK FOOTER //
// ./src/routes/home/index.js